import * as tslib_1 from "tslib";
import { EventEmitter, OnInit, } from '@angular/core';
import { IGridSource, ODataGridComponent, } from '@pages/generics/grid';
import { ModalService, PackageService, ProcessService, } from '@services';
import { UiGridComponent } from '@uipath/angular/components/ui-grid';
import sortBy from 'lodash-es/sortBy';
import { finalize, takeUntil, } from 'rxjs/operators';
var ProcessVersionSource = /** @class */ (function () {
    function ProcessVersionSource(_packageService) {
        this._packageService = _packageService;
    }
    Object.defineProperty(ProcessVersionSource.prototype, "mapper", {
        get: function () {
            return this._packageService.mapper;
        },
        enumerable: true,
        configurable: true
    });
    ProcessVersionSource.prototype.get = function (qo) {
        return this._packageService.getVersions(this.release.processKey, qo);
    };
    return ProcessVersionSource;
}());
export { ProcessVersionSource };
var ProcessVersionsGridComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ProcessVersionsGridComponent, _super);
    function ProcessVersionsGridComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.update = new EventEmitter();
        _this.isProcessAssociated = true;
        _this._processService = _this._injector.get(ProcessService);
        _this._modalService = _this._injector.get(ModalService);
        _this._refreshRelease = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var release;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._processService
                            .getInstance(this.release.id, ['ReleaseVersions'])
                            .toPromise()];
                    case 1:
                        release = _a.sent();
                        // TODO: investigate if we can do this better with the new mapper
                        if (release.arguments && release.arguments.input) {
                            release.arguments.input
                                .forEach(function (inputArg) { return inputArg.source = inputArg.hasDefault ? 'package' : null; });
                        }
                        this.update.emit([release]);
                        this._grid.refresh.next();
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    ProcessVersionsGridComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._service.release = this.release;
        this._filters$.next([{
                method: 'contains',
                property: 'key',
                value: this.release.processKey,
            }]);
        this.data$
            .pipe(takeUntil(this._destroyed$))
            .subscribe(function (data) { return _this._onRefreshVersionItems(data); });
    };
    ProcessVersionsGridComponent.prototype.processVersionIsCurrentVersion = function (processVersion) {
        return this.release.processVersion === processVersion.version;
    };
    ProcessVersionsGridComponent.prototype.getProcessVersionUsageDate = function (processVersion) {
        if (!this.release.releaseVersions) {
            return null;
        }
        var orderedReleaseVersions = sortBy(this.release.releaseVersions.filter(function (releaseVersion) { return releaseVersion.versionNumber === processVersion.version; }), function (pv) { return pv.creationTime; });
        return orderedReleaseVersions.length !== 0
            ? orderedReleaseVersions[orderedReleaseVersions.length - 1].creationTime
            : null;
    };
    ProcessVersionsGridComponent.prototype.onUpdateClick = function (processVersion) {
        var _this = this;
        var confirmationMessage = this._translate.instant('versions_modal_update_release_version_message', {
            name: this.release.name,
            version: processVersion.version,
        });
        this._modalService.onConfirm(processVersion.key, function () {
            _this.loading$.next(true);
            _this._processService
                .updateReleaseToSpecificVersion(_this.release.id, processVersion.version)
                .pipe(finalize(function () { return _this.loading$.next(false); }))
                .subscribe(_this._refreshRelease);
        }, function () { }, confirmationMessage);
    };
    ProcessVersionsGridComponent.prototype.onUpdateToLatestClick = function () {
        var _this = this;
        var confirmationMessage = this._translate.instant('versions_modal_update_release_latest_version_message', this.release);
        this._modalService.onConfirm(this.release.name, function () {
            _this.loading$.next(true);
            _this._processService
                .updateReleaseToLatestVersion(_this.release.id)
                .pipe(finalize(function () { return _this.loading$.next(false); }))
                .subscribe(_this._refreshRelease);
        }, function () { }, confirmationMessage);
    };
    ProcessVersionsGridComponent.prototype.onRollbackToPreviousClick = function () {
        var _this = this;
        var confirmationMessage = this._translate
            .instant('versions_modal_update_release_last_version_message', this.release);
        this._modalService
            .onConfirm(this.release.name, function () {
            _this.loading$.next(true);
            _this._processService
                .rollbackReleaseToPreviousVersion(_this.release.id)
                .pipe(finalize(function () { return _this.loading$.next(false); }))
                .subscribe(_this._refreshRelease);
        }, function () { }, confirmationMessage);
    };
    ProcessVersionsGridComponent.prototype._onRefreshVersionItems = function (data) {
        var latestVersion = data.find(function (a) { return a.isLatestVersion; });
        this.isUpdatedToLatestVersion = !!latestVersion && latestVersion.version === this.release.processVersion;
        this.isFirstVersion = this.release.releaseVersions.length === 1;
        this.isProcessAssociated = data.length !== 0;
    };
    return ProcessVersionsGridComponent;
}(ODataGridComponent));
export { ProcessVersionsGridComponent };
